export const getNotificationContent = (content: string) => {
    const translations: { [key: string]: string } = {
        'event_created': 'Nouvel événement créé',
        'event_deleted': 'Événement annulé',
        'event_updated': 'Événement modifié',
        'event_accepted': 'Invitation acceptée',
        'event_refused': 'Invitation refusée',
        'event_canceled': 'Invitation annulée',
        'person_created': 'Nouvelle personne soutenue créée',
        'appointment_created': 'Demande de rendez-vous',
    };
    return translations[content] || content;
};

export const getNotificationRouting = (type: string, id: string|number) => {
    const routes: { [key: string]: string } = {
        'person': `/app/admin/persons/${id}`,
        'projectappointment': `/app/admin/persons/${id}`,
        'agendaevent': `/app/admin/calendar`,
    };
    return routes[type] || type;
};